













































import { Component, Vue } from "vue-property-decorator";
import Card from "@/components/ui/card/Card.vue";
import CardTitle from "@/components/ui/card/CardTitle.vue";
import { metamaskModule } from "@/store";
import DashboardLayoutSection from "@/components/layouts/dashboard/DashboardLayoutSection.vue";
import DashboardBalance from "@/components/dashboard/DashboardBalance.vue";
import DashboardChart from "@/components/dashboard/DashboardChart.vue";
import DashboardNews from "@/components/dashboard/DashboardNews.vue";
import DashboardVesting from "@/components/dashboard/DashboardVesting.vue";
import DashboardSurveys from "@/components/dashboard/DashboardSurveys.vue";
import DashboardLayoutSectionTitle from "@/components/layouts/dashboard/DashboardLayoutSectionTitle.vue";
import Loader from "@/components/ui/Loader.vue";
import DashboardStaking from "@/components/dashboard/DashboardStaking.vue";

@Component({
  components: {
    DashboardStaking,
    Loader,
    DashboardLayoutSectionTitle,
    DashboardVesting,
    DashboardChart,
    DashboardNews,
    DashboardBalance,
    DashboardLayoutSection,
    DashboardSurveys,
    CardTitle,
    Card,
  },
})
export default class Dashboard extends Vue {
  get account(): string {
    return metamaskModule.account;
  }
}
